import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import API from 'config/ApiConfig';


export default function UpdateUserForm({ onSubmit, onClose }) {
  // const API_BASE_URL = 'http://localhost:5000/api/admin/user';
  const API_BASE_URL = API.API_ADMIN + '/user';
  const { userId } = useParams(); // Ambil userId dari URL
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    role: 'siswa',
    telepon: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      console.error('User ID is missing');
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await fetch( API_BASE_URL + `/${userId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setFormData({
          username: data.username,
          role: data.role,
          telepon: data.telepon,
        });
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [userId]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validate = () => {
    const errors = {};
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validate()) {
      try {
        const response = await fetch(API_BASE_URL + `/${userId}`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
  
        if (!response.ok) {
          // Cek apakah respons adalah JSON
          const errorText = await response.text(); // Mengambil teks dari respons
          console.error('Error response text:', errorText);
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json(); // Menguraikan respons JSON
        console.log('User updated:', data);
  
        setFormData({
          username: '',
          password: '',
          newPassword: '',
          role: 'siswa',
          telepon: '',
        });
        setErrors({});
        if (onSubmit) onSubmit(data);
        if (onClose) onClose();
      } catch (error) {
        console.error('Error updating user:', error);
      }
    }
  };
  const handleClick = () =>{
    alert("Berhasil Mengupdate Data User");
    window.location.href = "/admin/user";
  }
  

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Update User</h3>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-2">
          <div>
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-at"></i>
            </span>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder='Username/Email'
              className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
            />
            {errors.username && <p className="text-red-500 text-xs">{errors.username}</p>}
          </div>

          <div>
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-star-of-life"></i>
            </span>
            <input
            disabled
              type="password"
              name="password"
              value={formData.password}
              placeholder='Password'
              onChange={handleChange}
              className="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
            />
            {errors.password && <p className="text-red-500 text-xs">{errors.password}</p>}
          </div>

          <div>
            <span className="mt-4 z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-user-cog"></i>
            </span>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="mt-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
            >
              <option value="admin">Admin</option>
              <option value="tentor">Tentor</option>
              <option value="siswa">Siswa</option>
            </select>
          </div>

          <div>
            <span className="mt-4 z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-phone"></i>
            </span>
            <input
              type="text"
              name="telepon"
              value={formData.telepon}
              placeholder='Nomor Telepon'
              onChange={handleChange}
              className="mt-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
            />
            {errors.telepon && <p className="text-red-500 text-xs">{errors.telepon}</p>}
          </div>

          <div>
            <button
              type="submit"
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
                onClick={handleClick}
            >
              Update User
            </button>
            <a href="/admin/user"><button
              type="button"
              onClick={onClose}
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Cancel
            </button></a>
          </div>
        </form>
      )}
    </div>
  );
}

UpdateUserForm.propTypes = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};
